import { Children, cloneElement, isValidElement, type PropsWithChildren } from 'react';

import { useOpenReportAbuseModal } from '../hooks/useOpenReportAbuseModal';
import { useValidateReportAbuseChildren } from '../hooks/useValidateReportAbuseChildren';
import type { ReportContext } from '../shared/types';

/**
 * Container component that wraps a child component and opens the report abuse modal on click.
 *
 * This component expects a single child that is a `<button>` or `<a>` element.
 */
export const ReportAbuseLinkContainer: React.FC<ReportAbuseLinkContainerProps> = ({
	children,
	v2,
	...reportContext
}) => {
	const { open, reportAbuseModals } = useOpenReportAbuseModal({ v2, reportContext });

	const child = Children.only(children);

	useValidateReportAbuseChildren(child);

	// eslint-disable-next-line @typescript-eslint/naming-convention
	if (!isValidElement<{ onClick?: () => void; 'data-qa'?: string }>(child)) {
		return null;
	}

	return (
		<>
			{cloneElement(child, {
				onClick: open,
				'data-qa': `report-abuse-${reportContext.type}`,
			})}
			{reportAbuseModals}
		</>
	);
};

type ReportAbuseLinkContainerProps = PropsWithChildren<ReportContext & { v2?: boolean }>;
